import React from 'react';
import { XCircleIcon } from '@heroicons/react/20/solid';

export interface ErrorTheme {
  primary?: string;
  secondary?: string;
}

export const ErrorIcon: React.FC = () => {
  return <XCircleIcon className="h-6 w-6 text-red-400" aria-hidden="true" />;
};
